import React from 'react';

type NavItem = {
  key: 'dashboard' | 'contracts' | 'invoices';
  label: string;
  description: string;
};

type SidebarProps = {
  activeView: NavItem['key'];
  onSelect: (view: NavItem['key']) => void;
};

const navItems: NavItem[] = [
  { key: 'dashboard', label: 'Insights', description: 'Pulse & alerts' },
  { key: 'contracts', label: 'Contracts', description: 'Terms & health' },
  { key: 'invoices', label: 'Invoices', description: 'Issuance & follow-up' },
];

export const Sidebar: React.FC<SidebarProps> = ({ activeView, onSelect }) => (
  <aside className="sidebar">
    <div>
      <div className="brand">
        <span className="badge bg-primary rounded-circle p-3" />
        <div>
          <div>Project Finance</div>
          <small className="text-secondary">Control Center</small>
        </div>
      </div>
      <hr className="border-secondary opacity-25" />
      <nav className="nav flex-column">
        {navItems.map((item) => (
          <button
            key={item.key}
            className={`nav-link text-start ${activeView === item.key ? 'active' : ''}`}
            type="button"
            onClick={() => onSelect(item.key)}
          >
            <div className="fw-semibold">{item.label}</div>
            <small className="d-block text-secondary">{item.description}</small>
          </button>
        ))}
      </nav>
    </div>
    <div className="mt-auto">
      <div className="small text-secondary mb-1">Account Team</div>
      <div className="d-flex align-items-center gap-2">
        <div className="rounded-circle bg-light" style={{ width: 36, height: 36 }} />
        <div>
          <div className="fw-semibold">Finance Desk</div>
          <small className="text-secondary">Reach out ›</small>
        </div>
      </div>
    </div>
  </aside>
);
